import dataService from "../../api";
import { startLoading, stopLoading, serverErrorMessage, showAlert, catchHandler } from "../../utils/helpers";


const state = {

    health: [],
    totalItems:0,
};

const getters = {
};

const mutations = {

    setHealth: (state, r) => (state.health = r),
    setTotalItems: (state, r) => (state.totalItems = r),

};

const actions = {

 
    async getHealth({ commit }, params) {
        try {
            const paramsString = Object.entries(params)
                .filter(([, val]) => val !== null)
                .map(([key, val]) => `${key}=${val}`)
                .join("&");
            startLoading()
            const response = await dataService.health.getHealth(paramsString);
            stopLoading()

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }

            commit("setHealth", response.data.health);

            commit("setTotalItems", response.data.totalItems);


        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },





};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
